import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const ColumnBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
});
